class Poll {
    loaded(questionID) {
        const votesCookie = window.Cookie.get('pVotes');
        let votes = typeof votesCookie != 'undefined' ? JSON.parse(votesCookie) : {};

        if (votes[questionID]) {
            this.getVotes(questionID, votes[questionID]);
        } else {
            // Set poll to loaded
            document.querySelectorAll(`.poll[data-question-id="${questionID}"]`).forEach((poll)=>{
                poll.classList.add('poll--loaded');
            });
        }
    }
    getVotes(questionId, voted) {
        axios.get(`/api/poll/question/${questionId}`)
            .then(response => {
                let totalCount = 0;

                response.data.answers.forEach((answer) => {totalCount += answer.vote_count})
                this.switchToResults(questionId, response.data.answers, parseInt(voted), totalCount);
            })
            .catch(error => console.error(error)); 
    }
    vote(questionId, answerId, ref) {
        // Set poll to loading
        document.querySelectorAll(`.poll[data-question-id="${questionId}"]`).forEach((poll)=>{
            poll.classList.remove('poll--loaded');
        });

        axios.get(`/api/poll/question/${questionId}`)
            .then(response => {
                this.castVote(response.data, answerId, ref);
            })
            .catch(error => console.error(error));
    }

    castVote(question, answerId, ref) {
        const postRef = ref.closest(".post");
        if (!postRef) {
            return;
        }

        const postID = postRef.dataset['postId'];

        axios.post(`/api/poll/vote/`, {
                questionId: question.id,
                answerId: answerId,
                postID: postID
            })
            .then(response => {
                const votesCookie = window.Cookie.get('pVotes');
                let newValues = typeof votesCookie != 'undefined' ? JSON.parse(votesCookie) : {};

                const attributes = {
                    expires: 730
                };

                // Push voted answer to votes
                newValues[question.id] = answerId;

                window.Cookie.set('pVotes', JSON.stringify(newValues), attributes);

                this.switchToResults(question.id, response.data.answers, answerId, response.data.total_votes);
            })
            .catch(error => console.error(error));
    }

    switchToResults(questionId, answers, votedAnswerId, totalVotes) {
        let html = `<div class="poll__results">`;
        
        // Find the most number of votes for an answer
        const maxVotes = Math.max.apply(Math, answers.map(function(o){return o.vote_count;}));
        
        answers.forEach(answer => {
            let percentage = Math.round((answer.vote_count * 100) / totalVotes);
            let animationTime = 2 / 100 * percentage;
            const isMaxVoted = maxVotes == answer.vote_count;
            let votedClass = answer.id == votedAnswerId ? ` poll__result--voted` : ``;
            let votedTitle = answer.id == votedAnswerId ? ` title="Du har röstat på detta valet - ${answer.answer} (${percentage}% | ${answer.vote_count} Votes)"` : ``;

            const checkmark = answer.id == votedAnswerId ? 
            `<svg class={this.props.className} width="16px" height="16px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                <circle id="check_mark" r="6" cx="8" cy="8" />
                <path id="check_circle" d="M8,1 C11.8659932,1 15,4.13400675 15,8 C15,11.8659932 11.8659932,15 8,15 C4.13400675,15 1,11.8659932 1,8 
                    C1,4.13400675 4.13400675,1 8,1 Z M11.1850357,4.61533737 L6.75,9.02524471 L5.01085567,7.28334999 L3.70821857,8.58886433 
                    L6.75,11.6192169 L12.4768734,5.91628551 L11.1850357,4.61533737 Z" />
            </svg>` : ``;

            html += `<div class="poll__result${votedClass}"${votedTitle}${isMaxVoted ? ' data-max="true"' : ''}>` + 
                `<span class="poll__result__answer">${answer.answer}${checkmark}</span>` + 
                `<span class="poll__result__percentage">${percentage}%</span>` + 
                `<div class="poll__result__bg" data-percentage="${percentage}" style="transition-duration: ${animationTime}s;"></div>` + 
                `</div>`;
        });

        html += `</div>`;

        // Change HTML
        document.querySelectorAll(`.poll[data-question-id="${questionId}"] .poll__answers`).forEach((poll)=>{
            poll.outerHTML = html;
        });

        // Set poll to loaded
        document.querySelectorAll(`.poll[data-question-id="${questionId}"]`).forEach((poll)=>{
            poll.classList.add('poll--loaded');
        });

        // Add percentage width to poll bars after, to get animation (delay needed)
        setTimeout(function() {
            // Set the width
            document.querySelectorAll(`.poll[data-question-id="${questionId}"] [data-percentage]`).forEach((barElement)=>{
                barElement.style.width = `${barElement.dataset.percentage}%`;
            });

            // Change color on max voted answer(s)
            setTimeout(function() {
                document.querySelectorAll(`.poll[data-question-id="${questionId}"] [data-max="true"]`).forEach((answer)=>{
                    answer.classList.add('poll__result--most-voted');
                });
            }, 2000);
        }, 100);
    }
}
window.poll = new Poll();
